// import { BodyEncryption, axiosClient } from "@/app/apibinding/apiClient";
import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { API_URL } from "../../APIRoute";
import { apiCall } from "../../AxiosService";
import { apiResponse } from "../../APIResponse";

export const makehook = createAsyncThunk(
    "makehook",
    async (data, { dispatch }) => {
        try {
            dispatch(setLoader(true));
            let resData = await apiCall(
                {
                    method: "POST",
                    url: API_URL.BASEURL + API_URL.WEBHOOKDETAILS.MAKEHOOK,
                    body: data,
                },
                true
            );
            let response = apiResponse(true, resData);
            dispatch(setLoader(false));
            return response;
        } catch (error) {
            dispatch(setLoader(false));
        }
    }
);

export const generatetoken = createAsyncThunk(
    "generatetoken",
    async (data, { dispatch }) => {
        try {
            dispatch(setLoader(true));
            let resData = await apiCall(
                {
                    method: "POST",
                    url: API_URL.BASEURL + API_URL.WEBHOOKDETAILS.GENERATETOKEN,
                    body: data,
                },
                true
            );
            let response = apiResponse(true, resData);
            dispatch(setLoader(false));
            return response;
        } catch (error) {
            dispatch(setLoader(false));
        }
    }
);

export const deletehook = createAsyncThunk(
    "deletehook",
    async (data, { dispatch }) => {
        try {
            dispatch(setLoader(true));
            let resData = await apiCall(
                {
                    method: "POST",
                    url: API_URL.BASEURL + API_URL.WEBHOOKDETAILS.DELETEHOOK,
                    body: data,
                },
                true
            );
            let response = apiResponse(false, resData);
            dispatch(setLoader(false));
            return response;
        } catch (error) {
            dispatch(setLoader(false));
        }
    }
);

export const detailsbyhooktype = createAsyncThunk(
    "detailsbyhooktype",
    async (data, { dispatch }) => {
        try {
            dispatch(setLoader(true));
            let resData = await apiCall(
                {
                    method: "POST",
                    url: API_URL.BASEURL + API_URL.WEBHOOKDETAILS.DETAILSBYHOOKTYPE,
                    body: data,
                },
                true
            );
            let response = apiResponse(false, resData);
            dispatch(setLoader(false));
            return response;
        } catch (error) {
            dispatch(setLoader(false));
        }
    }
);

const initialState = {
    makehookData: {
        data: null,
        error: null,
    },
    generatetokenData: {
        data: null,
        error: null,
    },
    deletehookData: {
        data: null,
        error: null,
    },
    detailsbyhooktypeData: {
        data: null,
        error: null,
    },


};

const WebhookDetailsSlice = createSlice({
    name: "WEBHOOKDETAILS",
    initialState,
    reducers: {
        setLoader: (state, action) => {
            state.isLoading = action.payload;
        }
    },

    extraReducers: (builder) => {
        builder
            .addCase(makehook.fulfilled, (state, action) => {
                state.makehookData.data = action.payload;
            })
            .addCase(makehook.rejected, (state, action) => {
                state.makehookData.error = action.error.message;
            })

            .addCase(generatetoken.fulfilled, (state, action) => {
                state.generatetokenData.data = action.payload;
            })
            .addCase(generatetoken.rejected, (state, action) => {
                state.generatetokenData.error = action.error.message;
            })

            .addCase(deletehook.fulfilled, (state, action) => {
                state.deletehookData.data = action.payload;
            })
            .addCase(deletehook.rejected, (state, action) => {
                state.deletehookData.error = action.error.message;
            })

            .addCase(detailsbyhooktype.fulfilled, (state, action) => {
                state.detailsbyhooktypeData.data = action.payload;
            })
            .addCase(detailsbyhooktype.rejected, (state, action) => {
                state.detailsbyhooktypeData.error = action.error.message;
            })

    },
});

export const { setLoader } = WebhookDetailsSlice.actions;
export default WebhookDetailsSlice.reducer;
